import type { LocaleOfStoreType, StoreType } from "@beautypie/core";

export type FallbackStoreType = "en" | "us";

type RegionOrFallbackStoreType = FallbackStoreType | "en-GB";

const storeFromPathname = (): RegionOrFallbackStoreType => {
  if (typeof window === "undefined") return "en-GB";
  const [, store] = window.location?.pathname.split("/") || [];
  return store as FallbackStoreType;
};

export const storeToLocale = (
  storeOrRegion: RegionOrFallbackStoreType
): LocaleOfStoreType => {
  switch (storeOrRegion) {
    case "us":
      return "en-US";
    case "en":
    default:
      return "en-GB";
  }
};

export const getDerivedLocale = (): LocaleOfStoreType => {
  return storeToLocale(storeFromPathname());
};

export const getStore = (
  locale: LocaleOfStoreType = getDerivedLocale()
): FallbackStoreType => {
  switch (locale) {
    case "en-US":
      return "us";
    case "en-GB":
    default:
      return "en";
  }
};

export const getRegion = (
  locale: LocaleOfStoreType = getDerivedLocale()
): StoreType => {
  return locale === "en-US" ? "us" : "uk";
};
